var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var fileState = {
    mainpage: {
        name: "",
        type: "",
        url: "",
        status: "loading",
        tempFileId: "",
        hasData: false,
    },
    displayPage: {
        name: "",
        type: "",
    },
};
export var fileReducer = function (state, action) {
    if (state === void 0) { state = fileState; }
    var payload = action.payload;
    switch (action.type) {
        case "changeMainPageFile":
            return __assign(__assign({}, state), { mainpage: __assign(__assign({}, state.mainpage), payload) });
        case "changeDisplayPageFile":
            return __assign(__assign({}, state), { displayPage: payload });
        default:
            return __assign({}, state);
    }
};
